<template>
    <HrDashboard></HrDashboard>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const HrDashboard = defineAsyncComponent(() =>
    import("../../components/DPAM_Hr/Dashboard/Table.vue")
);

export default {
    name: "DPAM_HR_Dashboard", //The name you are in should not equal the name of the component you are importing.
    components: { HrDashboard, AuthLayout },
};
</script>
